//Styles
import "./Create.css";

import React, { useEffect, useRef, useState } from "react";
//import { useFetch } from "../../hooks/useFetch";
import { useHistory } from "react-router-dom";
import { projectFirestore } from "../../firebase/config";
import useSearch from "../../hooks/useSearch";

export default function Create() {
  const [title, setTitle] = useState("");
  const [method, setMethod] = useState("");
  const [cookingTime, setCookingTime] = useState("");
  const [newIngredient, setNewIngredient] = useState("");
  const [ingredients, setIngredients] = useState([]);

  const { setTerm } = useSearch();

  //const {postData, data} = useFetch("http://localhost:3000/recipes", "POST")

  const ingInput = useRef(null);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();

    const doc = {
      title,
      ingredients,
      method,
      cookingTime: cookingTime + " minutes",
    };

    try {
      projectFirestore
        .collection("recipes")
        .add(doc)
        .then(() => {
          history.push("/");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const ing = newIngredient.trim();
    if (ing && !ingredients.includes(ing))
      setIngredients((prev) => [...prev, ing]);
    setNewIngredient("");
    ingInput.current.focus();
  };

  /*/Redirect the user when he gets data response
  useEffect(() => {
   if (data) history.push("/")
  }, [data, history])*/
  useEffect(() => {
    setTerm("");
  }, [setTerm]);

  return (
    <div className="create">
      <h2 className="page-title">Add a New Recipe</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Recipe title:</span>
          <input
            type="text"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            required
          />
        </label>

        <label>
          <span>Recipe ingredients:</span>
          <div className="ingredients">
            <input
              ref={ingInput}
              type="test"
              onChange={(e) => setNewIngredient(e.target.value)}
              value={newIngredient}
            />
            <button onClick={handleAdd} className="btn">
              add
            </button>
          </div>
        </label>

        <p>
          Current ingredients: <em>{ingredients.join(", ")}</em>
        </p>

        <label>
          <span>Recipe method:</span>
          <textarea
            onChange={(e) => setMethod(e.target.value)}
            value={method}
            required
          />
        </label>

        <label>
          <span>Cooking time (minutes)</span>
          <input
            type="number"
            onChange={(e) => setCookingTime(e.target.value)}
            value={cookingTime}
            required
          />
        </label>

        <button className="btn">Submit</button>
      </form>
    </div>
  );
}
